<section *ngIf="isPreviewActive">
	<h2 class="preview-message">{{ 'Branding_PreviewMessage' | translate }}</h2>
	<a class="btn-preview" vbBtnPrimary uiSref="portal.admin.system-settings.branding-settings" [uiParams]="{accountId: accountId}">
		{{ 'Branding_PreviewExitLabel' | translate }}
	</a>
</section>
